export const Challenge1337PageLeaderboardMentions = ({ data, hasWinners }) => {
  const limit = 104;
console.log(data);

  const dataList = data?.slice(0, limit);

  return (
    <div className="leet-challenge__honorable">
      <div className="honorable">
        <h2>Honorable mentions</h2>
        <div className="honorable__list">
          {data?.length === 0 && (
            <div className="honorable__item">
              No honorable mentions yet.
              {hasWinners && " Only winners!"}
            </div>
          )}

          {dataList &&
            dataList.map((doc, index) => {
              return (
                <div className="honorable__item" key={index}>
                  {doc.userName} ({doc.score})
                </div>
              );
            })}
        </div>

        <div className="honorable__overflow">
          {data && data?.length > limit && (
            <p> {data?.length - limit} more honorable mentions</p>
          )}
        </div>
      </div>
    </div>
  );
};
